export default {
  tariff: 'tariff',
  linkCard: 'linkCard',
};



// WEBPACK FOOTER //
// ./src/models/PaymentModes.js